module.exports = __webpack_public_path__ + "assets/img/email-9d3d0b23.png";